import React, { Component } from 'react'

export class TopBullet extends Component {
    render() {
        const bgColor = {
            border: '3px solid ' + this.props.bgcolor
        }

        let txtColor = {
            color: this.props.bgcolor
        }

        if(this.props.score < 70) {
            txtColor = {
                color: '#666'
            }
        }
        
        return (
                <div className="circleLine tooltip">
                <div style={bgColor} className="circleTop"></div>
                    <span style={txtColor} className="tooltiptext tooltip-top">{this.props.score}%</span>
                </div>
        )
    }
}

export default TopBullet
